import translate from 'utils/apa/translations';
import { GetRegion } from 'constants.js';
import { getTranslation } from 'utils/getTranslation';

export const URL_REDIRECT = `/${GetRegion()}/homeuser`;

export const CODE_CLOSE_SESSION = 'update_successful_sessions_closed';
export const CODE_OLD_PASSWORD_ERROR = 'error_params_old_password';

export const MODAL_ERROR = 'ErrorSimple';
export const MODAL_SUCCESS = 'SuccessSimple';

export const emptyValidation = (translations)=> getTranslation('profile_empty_field', translations);
export const minLengthValidation = (translations)=> getTranslation('profile_password_min_length', translations);
export const noMatchValidation = (translations)=> getTranslation('profile_password_no_match', translations);

export const getLabels = (translations) => {
  const title = getTranslation('profile_modify_password_title', translations);
  const subTitle = getTranslation('profile_modify_password_subtitle', translations);
  const password = getTranslation('password');
  const recomendation = getTranslation('profile_modify_password_recommendation', translations);
  const placeholder = getTranslation('profile_password', translations);
  const oldPassword = getTranslation('profile_password_current', translations);
  const newPassword = getTranslation('profile_password_new', translations);
  const controlPassword = getTranslation('profile_password_repeat', translations);
  const required = getTranslation('profile_required_fields', translations);
  const modify = getTranslation('profile_button_modify', translations);
  const cancel = getTranslation('profile_button_cancel', translations);
  const save = getTranslation('profile_button_save', translations);

  return {
    title,
    subTitle,
    password,
    recomendation,
    placeholder,
    oldPassword,
    newPassword,
    controlPassword,
    required,
    modify,
    cancel,
    save,
  };
};

export const getMessage = ({ code, message, translations }) => getTranslation(code, translations) || message;
